import { compose } from 'redux'
import { connect } from 'react-redux'
import hasUpdateProgram from '../../hoc/hasUpdateProgram'
import toJS from '../../hoc/toJS'
import config from '../../config.json'
import PageProgramPage from '../../components/PageProgram/PageProgramPage'
import { programFetchRequest } from '../../actions';
import { AUTH_CAPS, PROGRAM_SELECTIONSDISPLAY_ITEMS, UI_GENERAL } from '../../constants/state'
import getData from '../../functions/getData'
import React from 'react'

const mapDispatchToProps = (dispatch, ownProps) => ({
    onFetchProgram: () => {
      dispatch(programFetchRequest())
    }
})

const mapStateToProps = state => ({
    [PROGRAM_SELECTIONSDISPLAY_ITEMS]: getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS),
    uiRequestOverlayType: getData(state, [UI_GENERAL, 'requestOverlay', 'overlayType']),
    caps: getData(state, AUTH_CAPS)

})

const PageProgramPageContainer = ({selectionDisplayItems, caps, goBackPath, onFetchProgram, programStatus, programError, uiRequestOverlayType, onUpdateProgram}) => {
    return <PageProgramPage
        pageTitleTransId={config.routes.program.transId}
        caps={caps}
        closePagePath={goBackPath}
        selectionDisplayItems={selectionDisplayItems}
        onFetchProgram={onFetchProgram}
        programStatus={programStatus}
        programError={programError}
        uiRequestOverlayType={uiRequestOverlayType}
        onUpdateProgram={onUpdateProgram}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(PageProgramPageContainer)